export default "__VITE_ASSET__CqJQmtgZ__"